
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
/* eslint-disable prettier/prettier */
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { ConversionSection } from "@/sections/ConversionSection";

const MiroToMural = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/MiroToMural"
        ogImage="/images/miro2mural-og-image.jpg"
      />

      <MagicianSection
        title={t("page/MiroToMural:title")}
        subtitle={t("page/MiroToMural:subtitle")}
        magicianLogoFile="mural"
        showStartsAt={false}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/MiroToMural:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/MiroToMural:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/miro-to-mural-example.png",
          alt: "Miro to Mural Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/MiroToMural:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/miro-to-mural-converted-file-elements.png",
          alt: t("page/MiroToMural:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/MiroToMural:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "NOTES",
            title: t(
              "page/MiroToMural:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/MiroToMural:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "ARROW-BLACK",
            title: t(
              "page/MiroToMural:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/MiroToMural:section/shareDesign.elements.folderStructureText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("page/MiroToMural:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("page/MiroToMural:section/conversion.badges.supportsAll"),
          },
          {
            iconType: "NOTES",
            text: t("page/MiroToMural:section/conversion.badges.stickyNotes"),
          },
          {
            iconType: "ARROW-BLACK",
            text: t("page/MiroToMural:section/conversion.badges.connectors"),
          },
        ]}
        elements={{
          from: {
            iconType: "MIRO",
            image: "/images/miro-to-mural-preview.png",
            title: "Miro Demo Preview",
          },
          to: {
            iconType: "MURAL",
            image: "/images/miro-mural-preview.jpg",
            title: "Mural Import Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection title={t("section/cta:titles.miroToMural")} href="#upload" />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default MiroToMural;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/miro-to-mural',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  